export default "__VITE_ASSET__sza55OZ0__";